// Function to execute when the page changes
function onPageChange() {
    // Your code to handle page change here
    console.log("Page changed");
}

// Event listener for changes in the URL (via History API)
// window.addEventListener("popstate", onPageChange);

// Event listener for changes in the DOM (if needed)
// document.addEventListener("DOMContentLoaded", onPageChange);

// Function to detect country from IP address
function detectCountryFromIP(ipAddress) {
    fetch(`http://ip-api.com/json/${ipAddress}`)
    .then(response => response.json())
    .then(data => {
        // Access the country from the response data
        const country = data.country;
        console.log(`Country: ${country}`);
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

// Example usage
// detectCountryFromIP('8.8.8.8'); // Replace with the IP address you want to detect
